import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-thin-left",
  "use": "icon-arrow-thin-left-usage",
  "viewBox": "0 0 800 800",
  "content": "<symbol viewBox=\"0 0 800 800\" id=\"icon-arrow-thin-left\">\n  <defs>\n    <style>\n      #icon-arrow-thin-left .cls-1 {\n        fill: #010002;\n      }\n    </style>\n  </defs>\n  <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->\n  <g>\n    <g id=\"icon-arrow-thin-left_Capa_1\">\n      <polygon class=\"cls-1\" points=\"261.6 661.6 282.4 640.8 56.3 414.7 800 414.7 800 385.3 56.3 385.3 282.4 159.2 261.6 138.4 0 400 261.6 661.6\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-thin-left.svg
// module id = IOtJ
// module chunks = 175